<div class="space-y-10">

  <!-- brand -->
  <div>
    <app-text-input [formGroup]="eventForm" id="brand" [maxLength]="50"
                    [value]="eventForm.value?.brand" [formError]="apiErrors.get('brand')"
                    label="Marca do Veículo (Obrigatório)"></app-text-input>
  </div>

  <!-- model -->
  <div>
    <app-text-input [formGroup]="eventForm" id="model" [maxLength]="50"
                    [value]="eventForm.value.model" [formError]="apiErrors.get('model')"
                    label="Modelo do Veículo (Obrigatório)"></app-text-input>
  </div>

  <!-- licensePlate -->
  <div>
    <app-text-input [formGroup]="eventForm" id="licensePlate" [maxLength]="50"
                    [value]="eventForm.value?.licensePlate" [formError]="apiErrors.get('licensePlate')"
                    label="Matrícula do Veículo (Obrigatório)"></app-text-input>
  </div>

  <!-- chassiNumber -->
  <div>
    <app-text-input [formGroup]="eventForm" id="chassisNumber" [maxLength]="50"
                    [value]="eventForm.value?.chassisNumber" [formError]="apiErrors.get('chassisNumber')"
                    label="Número do Chassis"></app-text-input>
  </div>
</div>
